import { NgTemplateOutlet } from '@angular/common';
import { Component, Input, output } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';

import { ClickActionType } from '@bn/primitives';

import { MenuItem } from '../models/menu-item.model';

@Component({
  selector: 'bn-layout-mobile-menu',
  templateUrl: './mobile-menu.component.html',
  styleUrls: ['./mobile-menu.component.scss'],
  imports: [NgTemplateOutlet, RouterLink, RouterLinkActive, FaIconComponent],
})
export class MobileMenuComponent {
  @Input() menuItems: MenuItem[] = [];
  @Input() isMobileMenuOpened = false;

  readonly toggleMenu = output<boolean>();

  public trackByRoute(index: number, menuItem: MenuItem): number | string {
    return menuItem.route ?? index;
  }

  public onMenuItemClick(action: ClickActionType): void {
    if (action === 'toggle-menu') {
      this.toggleMenu.emit(!this.isMobileMenuOpened);
    }
  }
}
